var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{attrs:{"src":_vm.posterUrl,"alt":""}}),_vm._v(" "),_c('van-empty',{directives:[{name:"show",rawName:"v-show",value:(_vm.noDataFlag),expression:"noDataFlag"}],attrs:{"description":"暂无数据"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02cacbf0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/operatingManual/module/posterPage.vue
// module id = null
// module chunks = 